<div class="d-flex flex-row" style="flex-wrap: wrap">
  <div class="car-chart">
    <div class="car-chart-title">All cars</div>
    <div echarts  [options]="carInstallsOption" style="height: 400px"></div>
  </div>

  <div class="car-chart">
    <div class="car-chart-title">Equipped cars</div>
    <div echarts [options]="carStatusesOption" style="height: 400px"></div>
  </div>
</div>




